import { resizeObservers } from '../ResizeObserverController';
import { ResizeObserverEntry } from '../ResizeObserverEntry';
import { calculateDepthForNode } from './calculateDepthForNode';
import { calculateBoxSize } from './calculateBoxSize';
const broadcastActiveObservations = () => {
    let shallowestDepth = Infinity;
    const callbacks = [];
    resizeObservers.forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) {
            return;
        }
        const entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            const entry = new ResizeObserverEntry(ot.target);
            const targetDepth = calculateDepthForNode(ot.target);
            entries.push(entry);
            ot.lastReportedSize = calculateBoxSize(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) {
                shallowestDepth = targetDepth;
            }
        });
        callbacks.push(function resizeObserverCallback() { ro.callback(entries, ro.observer); });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for (let callback of callbacks) {
        callback();
    }
    return shallowestDepth;
};
export { broadcastActiveObservations };
